export default { options: { label: 'Tags' } }
